import { PermissionsGate } from 'features/auth'
import { SiteMapVizEditorPermissionsList } from 'features/siteMapViz'
import React, { FC } from 'react'
import { GeckoSiteModel, GeckoUnit } from 'types'

import { MapPlusMenuOverlayContainer } from './editMode/plusMenu/MapPlusMenuOverlayContainer'
import { MapPopupMenus } from './MapPopupMenus'

interface MapEditorOverlaysContainerProps {
  addMapFeatureMenuLocationRef: React.RefObject<HTMLDivElement> | undefined
  siteModel: GeckoSiteModel
  allUnitsAtSite: ReadonlyArray<GeckoUnit>
}
export const MapEditorOverlaysContainer: FC<MapEditorOverlaysContainerProps> = (
  props
) => {
  return (
    <PermissionsGate requires={SiteMapVizEditorPermissionsList}>
      <MapPlusMenuOverlayContainer
        divToPortalInto={props.addMapFeatureMenuLocationRef}
      />
      <MapPopupMenus
        siteModel={props.siteModel}
        allUnitsAtSite={props.allUnitsAtSite}
      />
    </PermissionsGate>
  )
}
